import BannerFeaturedContent from "@/components/Menu/BannerFeaturedContent.vue";
import { builderCta } from "@/helpers/builder-init/index";

export const bannerFeaturedContentInit = {
    component: BannerFeaturedContent,
    name: "Banner Featured Content",
    models: ["mega-menu-header"],
    inputs: [
        {
            name: "title",
            type: "string",
            defaultValue: ""
        },
        {
            name: "featuredItems",
            type: "list",
            defaultValue: [],
            subFields: [
                {
                    name: "title",
                    friendlyName: "Title",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "badge",
                    friendlyName: "Badge",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "captions",
                    friendlyName: "Captions",
                    type: "list",
                    defaultValue: [],
                    subFields: [
                        {
                            name: "text",
                            friendlyName: "Text",
                            type: "string",
                            defaultValue: ""
                        },
                        {
                            name: "featuredPrice",
                            friendlyName: "Featured Price",
                            type: "number",
                            defaultValue: 0
                        }
                    ]
                },
                {
                    name: "alt",
                    friendlyName: "Alt Text",
                    type: "string",
                    defaultValue: ""
                },
                {
                    name: "image",
                    friendlyName: "Image",
                    helperText: "Image should be 300x300px",
                    type: "file",
                    allowedFileTypes: ["jpeg", "png", "svg"]
                },
                {
                    name: "cta",
                    friendlyName: "CTA",
                    type: "object",
                    defaultValue: builderCta.defaultValue,
                    subFields: [
                        ...builderCta.subFields.filter((field) =>
                            ["label", "url", "aria-label"].includes(field.name)
                        )
                    ]
                }
            ]
        }
    ]
};
